import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";



const YoYBarChart = ({yeardata}) => {
  console.log(yeardata, typeof yeardata);
  const transformedData = Object.entries(yeardata).map(([year, emissions]) => ({
    year,
    emissions,
  }));

  
  return (
    <div className="bg-white p-4 shadow-md rounded-lg w-full">
      <h2 className="text-lg font-bold mb-3">Year-over-Year Carbon Emissions</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={transformedData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="emissions" fill="#1890ff" name="Emissions (tonnes CO₂)" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default YoYBarChart;
